
/* injects from baggage-loader */

import Config from "../../../config/main";
import Helpers from "../../helperFunctions";

export const getBetBuilder = (games, gameType) => {
	const gameIds = [];
	const sportAliases = new Set();

	games.forEach(game => {
		gameIds.push(game.gameId);
		sportAliases.add(game.sportAlias);
	});

	let mergedMarkets = Helpers.asianViewMarketMerge(Array.from(sportAliases), Config.asianViewMarket, gameType);

	let outright = { display_key: "OUTRIGHT" };
	mergedMarkets.push(outright);

	let req = {
		source: "betting",
		subscribe: "true",
		what: {
			sport: ["id", "name", "alias", "order"],
			competition: ["id", "name"],
			region: ["id", "name", "alias"],
			game: [
				"id",
				"start_ts",
				"show_type",
				"team1_name",
				"team2_name",
				"team1_external_id",
				"team2_external_id",
				"type",
				"info",
				"markets_count",
				"extra",
				"is_blocked",
				"exclude_ids",
				"is_stat_available",
				"game_number",
				"game_external_id",
				"is_live",
				"is_neutral_venue",
				"game_info",
				"sportcast_id",
			],
			event: ["name", "id", "base", "type", "type_1", "price", "show_type"],
			market: [
				"base",
				"id",
				"name",
				"order",
				"sequence",
				"show_type",
				"cashout",
				"display_key",
				"display_sub_key",
				"market_type",
				"home_score",
				"away_score",
				"main_order",
				"optimal",
				"col_count",
				"group_id",
				"express_id",
				"group_name",
			],
		},
		where: {
			game: {
				id: { "@in": gameIds },
				type: { "@in": [0, 2] },
			},
			market: { "@or": mergedMarkets },
		},
	};

	return req;
};
